module.exports = __webpack_public_path__ + "img/hhnm_gallery2.2775205c.jpg";